/**
 * rcmUiRcmSiteRepository
 */
angular.module('rcm-ui').service(
    'rcmUiRcmSiteRepository',
    [
        'pipeRatApiRepositoryService',
        function (
            pipeRatApiRepositoryService
        ) {
            return pipeRatApiRepositoryService.getNewRepository(
                '/api/resource/rcm-site',
                'rcmUiRcmSiteRepository'
            );
        },
    ]
);
